import React from 'react';
import PropTypes from 'prop-types';
import WithStoryPriceTag from 'routes/toiplushome/hoc/WithStoryPriceTag';

import Card from 'components_v2/common/CardV2/Card';
import s from './toipRowLayout.scss';

const TpLeadLeftColumn = ({ item, userData, paidStoriesMsid, priceTag }) => {
  if (!item || !item.length) {
    return null;
  }

  return (
    <div className={s.leftWrapper}>
      {item.map((el, i) => (
        <Card
          data={el}
          showDescription
          isVerticalTile
          timeStampHtml
          imgWidth={i === 0 ? 600 : 300}
          istoipListing
          isVertical
          isTopWidget
          gaPageName="TOIPlus_HomePage"
          tpPageName="toiphome"
          toiPCardTheme={i === 1}
          userData={userData}
          paidStoriesMsid={paidStoriesMsid}
          priceTag={priceTag?.h1}
          shouldNotlazyloadImage={el.isLead === 'featured'}
        />
      ))}
    </div>
  );
};

export default React.memo(WithStoryPriceTag(TpLeadLeftColumn));

TpLeadLeftColumn.propTypes = {
  item: PropTypes.arrayOf(PropTypes.object),
  userData: PropTypes.shape({}),
  paidStoriesMsid: PropTypes.arrayOf(PropTypes.string),
  priceTag: PropTypes.shape({}),
};

TpLeadLeftColumn.defaultProps = {
  item: [],
  userData: undefined,
  paidStoriesMsid: [],
  priceTag: {},
};
